import { render, staticRenderFns } from "./CardPopUp.vue?vue&type=template&id=a3229618&scoped=true"
import script from "./CardPopUp.vue?vue&type=script&lang=js"
export * from "./CardPopUp.vue?vue&type=script&lang=js"
import style0 from "./CardPopUp.vue?vue&type=style&index=0&id=a3229618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3229618",
  null
  
)

export default component.exports